export const getInitials = (
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null
) => {
  const f = firstName?.charAt(0) ?? '';
  const l = lastName?.charAt(0) ?? '';
  const result = (f + l).toUpperCase();
  if (result) return result;
  if (email) return email.charAt(0).toUpperCase();
  return '?';
};

export const getInitialsFromFullName = (name: string) =>
  name
    .split(' ')
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
